import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import { useHistory } from "react-router";

import Cookies from "universal-cookie";
// import { useSelector } from "react-redux";
import { API_POST } from "../../helpers/api";
const cookies = new Cookies();

export default function Avatar(props) {
  let { t, label, ...args } = props;
  // const USER = "USER";
  const history = useHistory();
  // const [isParticipant, setIsParticipant] = useState(true);
  // const user = useSelector((state) => state.authorization.user);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const logout = async () => {
    const cookieTicket = cookies.get("ticket") || "";
    if (cookieTicket) {
      cookies.remove("user");
      cookies.remove("ticket");
      await logoutRequest();
      return window.location.replace(
        `${process.env.REACT_APP_CAS_URL}/cas/logout`
      );
    }
    await logoutRequest();
    cookies.remove("user");
    window.location.replace(`/login`);
  };
  // useEffect(() => {
  //   if (user.roles.includes("ADMIN")) {
  //     setIsParticipant(false);
  //   }
  // }, []);
  const logoutRequest = () => {
    return API_POST("authentication/logout");
  };
  const handleRedirect = (path) => {
    history.push(path);
    setIsMenuOpen(false);
  };
  return (
    <div
      className="km__c--avatar-wrapper"
      onBlur={() => setIsMenuOpen(false)}
      tabIndex="0"
    >
      <div
        className="km__c--avatar-container"
        onClick={() => setIsMenuOpen(true)}
        {...args}
      >
        <div className="km__c--avatar">
          <span>{label.substring(0, 2)}</span>
        </div>
        <span className="km__c--avatar-text">{label}</span>
      </div>
      <div
        className={`km__c--avatar-menu-container ${
          isMenuOpen ? "km__c--avatar-menu-is-open" : ""
        }`}
      >
        <div
          className="km__c--avatar-menu-item"
          onClick={() => handleRedirect("/operation-history")}
          id="nav-operation-history"
        >
          <Icon name="file-text" /> {t("pages.default.operationHistory.title")}
        </div>

        {/* {isParticipant &&  */}
        <div
          className="km__c--avatar-menu-item"
          onClick={() => handleRedirect("/user-parameters")}
          id="nav-user-parameters"
        >
          <Icon name="file-text" /> {t("pages.default.userParameters.title")}
        </div>
        {/* } */}
        <div
          className="km__c--avatar-menu-item"
          onClick={logout}
          id="nav-logout"
        >
          <Icon name="x-circle" /> {t("ui.default.logout")}
        </div>
      </div>
    </div>
  );
}
Avatar.propTypes = {
  label: PropTypes.string,
};
